import { LoanTypeField } from './components/LoanTypeField';
import { TermInfo } from './components/TermInfo/TermInfo';
import { BfiApprovalDateField } from './components/BfiApprovalDateField';
import { NoteDateField } from './components/NoteDateField';
import { MaturityDateField } from './components/MaturityDateField';
import { MasterNoteBfiNumberField } from './components/MasterNoteBfiNumberField';
import { BfiNumberField } from './components/BfiNumberField';
import { LoanNumberField } from './components/LoanNumberField';
import { PointOfContactField } from './components/PointOfContactField';
import { UnderwriterField } from './components/UnderwriterField';
import { CallCodeField } from './components/CallCodeField';
import { FdilaAgreementField } from './components/FdilaAgreementField';
import { FdilaAgreementTermsField } from './components/FdilaAgreementTermsField';
import { ItemRow } from '../../ItemRow/ItemRow';
import {
    Expander,
    ExpanderBorderRoundingStyle,
    ExpanderBorderStyle,
    ExpanderButtonStyle,
    ExpanderHeaderSpacing,
    ExpanderTheme,
} from '@apply/components';
import '../styles/_sectionContent.scss';

/**
 * The Setup fields of the "Setup & Borrower" step: a new version of the Setup section of EditStdLoanModal. Each field
 * reads and writes its own value in the standard loan store.
 */
export const Setup = () => {
    return (
        <Expander
            header={<h2>Setup</h2>}
            initialExpanded={true}
            theme={ExpanderTheme.White}
            buttonStyle={ExpanderButtonStyle.NoRounding}
            borderRoundingStyle={ExpanderBorderRoundingStyle.NoRounding}
            borderStyle={ExpanderBorderStyle.None}
            headerSpacing={ExpanderHeaderSpacing.None}
            width='auto'
            height='30px'
        >
            <div className='setupAndBorrowerSectionContent'>
                <ItemRow>
                    <LoanTypeField />
                </ItemRow>
                <ItemRow>
                    <TermInfo />
                </ItemRow>
                <ItemRow>
                    <BfiApprovalDateField />
                </ItemRow>
                <ItemRow>
                    <NoteDateField />
                </ItemRow>
                <ItemRow>
                    <MaturityDateField />
                </ItemRow>
                <ItemRow>
                    <MasterNoteBfiNumberField />
                </ItemRow>
                <ItemRow>
                    <BfiNumberField />
                    <LoanNumberField />
                </ItemRow>
                <ItemRow>
                    <PointOfContactField />
                </ItemRow>
                <ItemRow>
                    <UnderwriterField />
                </ItemRow>
                <ItemRow>
                    <CallCodeField />
                </ItemRow>
                <ItemRow>
                    <FdilaAgreementField />
                </ItemRow>
                <ItemRow>
                    <FdilaAgreementTermsField />
                </ItemRow>
            </div>
        </Expander>
    );
};
